/**
 * Created by adam on 7/26/17.
 */

if (window['jQuery']) {
    window.jQuery(function ($) {
        var relatedSection=$("section.related-articles");

        if (relatedSection && relatedSection.length>0){
            var variantId=relatedSection.attr("data-variant");
            if (variantId){
                trackTest("variant_selected",variantId);
            }
        }
    });
}